import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormulasComponent } from './formulas/formulas.component';
import { FormulasAddComponent } from './formulas-add/formulas-add.component';

import { TableModule } from '../../components/table/table.module';
import { MatIconModule } from '@angular/material/icon';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    FormulasComponent,
    FormulasAddComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,

    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSelectModule
  ]
})
export class FormulasModule { }
